var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 11.6922C11.4363 11.6922 12.6004 10.5281 12.6004 9.09219C12.6004 7.65625 11.4363 6.49219 10.0004 6.49219C8.56445 6.49219 7.40039 7.65625 7.40039 9.09219C7.40039 10.5281 8.56445 11.6922 10.0004 11.6922Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01675 7.57533C4.65842 0.358661 15.3501 0.366994 16.9834 7.58366C17.9417 11.817 15.3084 15.4003 13.0001 17.617C11.3251 19.2337 8.67508 19.2337 6.99175 17.617C4.69175 15.4003 2.05842 11.8087 3.01675 7.57533Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationProfile);
export default __webpack_public_path__ + "static/media/location-profile.89e2eb4dbd28677bfe4374ef939c2318.svg";
export { ForwardRef as ReactComponent };